export default "<div class=\"entry\">\n<h1>{{title}}</h1>\n<div class=\"body\">\n{{body}}\n</div>\n</div>\n"